import React, { useEffect } from "react";
import ReasonForVisitCard from "./ReasonForVisitCard";
import { useBookingReasonsNavigation } from "../../../hooks";

interface IReasonForVisitElement{
  value: string,
  label: string
}

interface IReasonForVisitCardList{
  reasonsList: IReasonForVisitElement[],
  selectedReasons?: string[];
  onReasonSelection?: (value: string)=> void
  icon?: JSX.Element;
  hasSocData?: boolean;
}

const ReasonForVisitCardList = ({
  reasonsList,
  onReasonSelection,
  selectedReasons,
  icon,
  hasSocData,
}: IReasonForVisitCardList) => {
  const { petsReasonSelection, currentNavigationIndex, setPetsReasonSelection }=useBookingReasonsNavigation();

  useEffect(()=>{
    if (hasSocData) {
      const updatedPetReasonSelection = petsReasonSelection.map((pet, index) =>
        index === currentNavigationIndex && (pet.selectedReasonCategory === "Wellness") ?
          { ...pet,
            selectedReasons: pet.selectedReasons?.includes("Semi-Annual Exam") ?
              pet.selectedReasons :
              [...(pet.selectedReasons || []), "Semi-Annual Exam"] } : pet,
      );

      setPetsReasonSelection(updatedPetReasonSelection);
    }
  }, [currentNavigationIndex]);

  return (
    <div className="w-full grid grid-cols-2 justify-items-center gap-2 px-1">
      {reasonsList.map((reason, index)=>{
        return (
          <ReasonForVisitCard
            key={index}
            title={reason.label}
            isSelected={selectedReasons ? selectedReasons.includes(reason.value) : false}
            value={reason.value}
            onCardClick={onReasonSelection && onReasonSelection}
            icon={icon}
          />
        );
      })}
    </div>
  );
};

export default ReasonForVisitCardList;
